import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions1 from '../../../actions/admin/patients_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'staff';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as UserActions from '../../../actions/user_actions';
import Pagination from "react-js-pagination";
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export var StaffList = React.createClass({
    getInitialState() {
        return {
            staffData: null, CurrentTab: 0,
            loader: true,
            isUploadCsvSubmitted: null,
            okModalMessage: null,

            //pagination
            pageNO: 1, // To make currentPage active in UI
            PageSize: 20,
            totalRecords: 20,
            searchWord: '',
            userStatusType: 'APPROVE',
            resendLinkClicked: false,
            showCsvModal: false,
            isShowDeleteModal: false,
            deleteStaffId: '',
            copiedToClipboard: false,
            searchCharacter: null
        }
    },
    componentWillMount() {

        this.props.Dispatch(UserActions.getUsersByRole(
            {
                "id": this.props.UserDetails.selectdUserFacilityID,
                "roleId": 8,
                "searchChar": "",
                "status": "APPROVE",
                "page": 1,
                "size": 20
            }
        ));

    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.UserDetails.UsersByRole && nextProps.UserDetails.UsersByRole.data && nextProps.UserDetails.UsersByRole.status === 200) {
            nextProps.UserDetails.UsersByRole.status = null;
            this.setState({ staffData: nextProps.UserDetails.UsersByRole.data.result, totalRecords: nextProps.UserDetails.UsersByRole.data.totalSize, loader: false });
        }
        else {
            this.setState({ loader: false });
        }
        if (this.state.resendLinkClicked) {
            if (nextProps.FacilitiesDetails.ResendLinkStatus) {
                this.setState({ oKModalMessage: nextProps.FacilitiesDetails.ResendLinkStatus.message });
                nextProps.FacilitiesDetails.ResendLinkStatus = null;
            }
            this.setState({ resendLinkClicked: false })
            let faciliti_id = this.props.UserDetails.selectdUserFacilityID;
            this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
        }
        // //let staff_data1 = nextProps.AllStaffData;
        // let staff_data = nextProps.UserDetails.UsersByRole;
        // //  if (staff_data.data.length == 0) { this.props.router.push('/admin/addStaff#new') }
        // staff_data && staff_data.status == 200 && this.setState({ staffData: staff_data.data.result, loader: false });
        // staff_data && staff_data.status != 200 && this.setState({ loader: false });
        // if (!nextProps.AllStaffData) {
        //     this.props.router.push('/admin/addStaff#new')
        // } else if (!nextProps.AllStaffData.data.length) {
        //     this.props.router.push('/admin/addStaff#new')
        // }
        // else if (nextProps.AllStaffData) {
        //     this.setState({ staffData: this.props.AllStaffData.data })
        // }

        if (this.state.isUploadCsvSubmitted && nextProps.UserDetails.FileUploadRegistrationResponse) {
            this.setState({ isUploadCsvSubmitted: null });
            if (nextProps.UserDetails.FileUploadRegistrationResponse.status === 200) {
                this.setState({ okModalMessage: nextProps.UserDetails.FileUploadRegistrationResponse.message })
            }
            else {
                this.setState({
                    okModalMessage: nextProps.UserDetails.FileUploadRegistrationResponse.message
                });
            }
        }
        if (nextProps.userDeleted && nextProps.userDeleted.status === 200) {
            this.handleSelect(2);
            this.props.Dispatch(UserActions.user_delete(null));
        }
    },

    handleSelect(index, last) {
        this.setState({ CurrentTab: index });
        let userStatusType = 'NA';

        switch (index) {
            case 0: {
                userStatusType = 'APPROVE'
            }
                break;
            case 1: {
                userStatusType = 'DEACTIVATED'
            }
                break;
            case 2: {
                userStatusType = 'ACCEPTED'
            }
                break;
            case 3: {
                userStatusType = 'EXPIRED'
            }
                break;
            case 4: {
                userStatusType = 'NA'
            }
                break;
            default:
                break;
        }

        this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
        this.setState({ userStatusType: userStatusType });
        this.props.Dispatch(UserActions.getUsersByRole(
            {
                "id": this.props.UserDetails.selectdUserFacilityID,
                "roleId": 8,
                "searchChar": this.state.searchWord,
                "status": userStatusType,
                "page": 1,
                "size": this.state.PageSize,
            }
        ));
    },

    closebox() {
        this.setState({ okModalMessage: null, });
        this.refs.fileUrl.value = null;
    },

    remove_error(event) {
        event.target.className = 'inputText';
        this.setState({ isEmailTrue: false, isurleTrue: false, isZipTrue: false });
    },
    addStaffMember() {
        this.props.router.push('/admin/addStaff#new');
    },

    editStaff(staffMemberData) {
        let target = event.target || event.srcElement || event.currentTarget;
        if (target.tagName === 'TD' || target.tagName === 'SPAN') {
            this.props.Dispatch(UserActions.setCurrentStaffMember(staffMemberData));
            this.props.router.push('/admin/editStaff');
        }
    },

    // need to remove
    searchPatient(event) {

        let value_name = event.target.value.toLowerCase();

        var currentlist = this.props.AllStaffData.data;

        var results = _.filter(currentlist, function (item) {

            return item.firstName.toLowerCase().indexOf(value_name) > -1 || item.lastName.toLowerCase().indexOf(value_name) > -1 || item.email.toLowerCase().indexOf(value_name) > -1 || item.mobile.toLowerCase().indexOf(value_name) > -1;
        });

        if (value_name.length == 0) {
            this.setState({ staffData: this.props.AllStaffData.data });
        }

        else { this.setState({ staffData: results }); }

        //  return fillterdList;
    },

    uploadStaffCSV(e) {
        var uploadedFile = e.target.files[0];
        var uploadedFilePath = uploadedFile.name;

        //To check if user upload any file
        var Extension = uploadedFilePath.substring(
            uploadedFilePath.lastIndexOf('.') + 1).toLowerCase();
        if (Extension == "xlsx" || Extension == "xls" || Extension == "csv") {
            var fileToUpload = new FormData();
            fileToUpload.append("fileToUpload", e.target.files[0]);
            this.setState({ isUploadCsvSubmitted: true });
            this.props.Dispatch(UserActions.uploadStaffRegistrationFile(fileToUpload, this.props.UserDetails.selectdUserFacilityID, this.props.UserDetails.loginData.data.id));
        }
        else {
            e.target.value = "";
            this.setState({ okModalMessage: 'Please upload the file with .xlsx, .xls, .csv extension only.' });
        }
    },
    resendLink(event) {
        let facilityId = this.props.UserDetails.selectdUserFacilityID;
        let id = event.target.attributes['data-staff_id'].value;
        this.props.Dispatch(FacilitiesActions.RequestResendLink(id + "/" + facilityId + "/" + this.props.UserDetails.selectedUserRoleID));
        this.setState({ resendLinkClicked: true })
    },

    //On Search word change -- To get searched facilities with entered character
    onSearchChange(event) {
        // if (event.target.value.trim().length === 0) {
        //     return;
        // }
        if (event.target.value.length >= 3) {
            if (event.target.value.includes('@')) {
                if (event.target.value.includes('.')) {
                    this.setState({ searchCharacter: event.target.value.trim(), searchWord: event.target.value.trim() });
                    setTimeout(() => {
                        console.log('after 3s in email')
                        this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
                        this.props.Dispatch(UserActions.getUsersByRole(
                            {
                                "id": this.props.UserDetails.selectdUserFacilityID,
                                "roleId": 8,
                                "searchChar": this.state.searchCharacter,
                                "status": this.state.userStatusType,
                                "page": 1,
                                "size": this.state.PageSize,
                            }
                        ));
                    }, 3000);
                }
            } else {
                this.setState({ searchCharacter: event.target.value.trim(), searchWord: event.target.value.trim() });
                setTimeout(() => {
                    console.log('after 3s no email')
                    this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
                    this.props.Dispatch(UserActions.getUsersByRole(
                        {
                            "id": this.props.UserDetails.selectdUserFacilityID,
                            "roleId": 8,
                            "searchChar": this.state.searchCharacter,
                            "status": this.state.userStatusType,
                            "page": 1,
                            "size": this.state.PageSize,
                        }
                    ));
                }, 3000);
            }
        } else if (event.target.value.length === 0) {
            this.setState({ searchWord: event.target.value.trim() });
            this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
            this.props.Dispatch(UserActions.getUsersByRole(
                {
                    "id": this.props.UserDetails.selectdUserFacilityID,
                    "roleId": 8,
                    "searchChar": event.target.value.trim(),
                    "status": this.state.userStatusType,
                    "page": 1,
                    "size": this.state.PageSize,
                }
            ));
        }
    },

    //on Page Change -- To get searched facilities with entered character
    onPageChange(pageNumber) {
        this.setState({ pageNO: pageNumber });
        this.props.Dispatch(UserActions.getUsersByRole(
            {
                "id": this.props.UserDetails.selectdUserFacilityID,
                "roleId": 8,
                "searchChar": this.state.searchWord,
                "status": this.state.userStatusType,
                "page": pageNumber,
                "size": this.state.PageSize,
            }
        ));
    },
    onDownload() {
        this.setState({ showCsvModal: false })
        window.open('https://ucdavis-prod.s3-us-west-1.amazonaws.com/Staff_upload_sample.csv');
    },

    // Delete pending staff Registrations
    deletePendingStaff(event) {
        this.setState({ isShowDeleteModal: true, deleteStaffId: event.id });
    },
    deleteStaffById() {
        this.props.Dispatch(UserActions.deleteUser(this.state.deleteStaffId));
        this.setState({ isShowDeleteModal: false });
    },

    formatDate(e) {
        if (e === null) {
            return "-";
        } else {
            var date = new Date(e);
            var year = date.getFullYear(), // get only two digits
                month = date.getMonth() + 1, day = date.getDate();
            return month + '/' + day + '/' + year;
        }
    },

    onCopyText() {
        this.setState({ copiedToClipboard: true });
    },
    copied() {
        this.setState({ copiedToClipboard: false })
    },
    render() {
        let class_name = "activate";
        var allStaffData = (this.state.staffData && this.state.staffData.length > 0) ? this.state.staffData.map(function (user, key) {

            return (<tr className="cursor" key={key} onClick={() => { this.editStaff(user) }} ><td>
                <CopyToClipboard text={user.user.guid} onCopy={this.onCopyText}>
                    <p className='guid' title={'copy to clipboard'}>{user.user.guid}</p>
                </CopyToClipboard>
            </td><td><span className="email-overflow" >{user.user.firstName + " " + user.user.lastName}</span></td><td><span className="email-overflow">{user.user.email}</span></td><td>{user.user.mobile}</td><td>{user.facilityRole && user.facilityRole.name ? user.facilityRole.name : ''}</td><td>{user.status === "APPROVE" && <span className="icon-edit" ></span>}</td><td>{user.status == "APPROVE" ? 'ACTIVE' : user.status == "ACCEPTED" ? "PENDING" : user.status}</td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        var activeStaffData = this.state.staffData && _.filter(this.state.staffData, function (item) {
            return item.status === "APPROVE";
        });
        activeStaffData = (activeStaffData && activeStaffData.length > 0) ? activeStaffData.map(function (user, key) {
            return (<tr className="cursor" key={key} onClick={() => { this.editStaff(user) }} ><td> <CopyToClipboard text={user.user.guid} onCopy={this.onCopyText}>
                <p className='guid' title={'copy to clipboard'}>{user.user.guid}</p>
            </CopyToClipboard></td><td><span className="email-overflow" >{user.user.firstName + " " + user.user.lastName}</span></td><td><span className="email-overflow">{user.user.email}</span></td><td>{user.user.mobile}</td><td>{user.facilityRole && user.facilityRole.name ? user.facilityRole.name : ''}</td><td><span className="icon-edit" ></span></td><td>{"ACTIVE"}</td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        var pendingStaffData = this.state.staffData && _.filter(this.state.staffData, function (item) {
            return item.status === "ACCEPTED";
        });

        pendingStaffData = (pendingStaffData && pendingStaffData.length > 0) ? pendingStaffData.map(function (user, key) {
            return (<tr className="cursor" key={key} ><td> <CopyToClipboard text={user.user.guid} onCopy={this.onCopyText}>
                <p className='guid' title={'copy to clipboard'}>{user.user.guid}</p>
            </CopyToClipboard></td><td><span className="email-overflow" >{user.user.firstName + " " + user.user.lastName}</span></td><td><span className="email-overflow">{user.user.email}</span></td><td>{user.user.mobile}</td><td>{user.facilityRole && user.facilityRole.name ? user.facilityRole.name : ''}</td><td>{"PENDING"}</td><td onClick={() => { this.deletePendingStaff(user) }}><img src={require('./../../../images/delete.png')} width={24} /></td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>)

        var expiredStaffData = this.state.staffData && _.filter(this.state.staffData, function (item) {
            return item.status === "EXPIRED";
        });
        expiredStaffData = (expiredStaffData && expiredStaffData.length > 0) ? expiredStaffData.map(function (user, key) {
            return (<tr className="cursor" key={key} onClick={() => { this.editStaff(user) }}><td> <CopyToClipboard text={user.user.guid} onCopy={this.onCopyText}>
                <p className='guid' title={'copy to clipboard'}>{user.user.guid}</p>
            </CopyToClipboard></td><td><span className="email-overflow" >{user.user.firstName + " " + user.user.lastName}</span></td><td><span className="email-overflow">{user.user.email}</span></td><td>{this.formatDate(user.statusUpdatedDate)}</td><td>{user.user.mobile}</td><td>{user.facilityRole && user.facilityRole.name ? user.facilityRole.name : ''}</td><td>{'EXPIRED'}</td><td><button data-staff_id={user.user.id} onClick={this.resendLink} className={class_name}>{"RESEND"}</button></td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        var deactiveStaffData = this.state.staffData && _.filter(this.state.staffData, function (item) {
            return item.status === "DEACTIVATED";
        });
        deactiveStaffData = (deactiveStaffData && deactiveStaffData.length > 0) ? deactiveStaffData.map(function (user, key) {
            return (<tr className="cursor" key={key} onClick={() => { this.editStaff(user) }}><td> <CopyToClipboard text={user.user.guid} onCopy={this.onCopyText}>
                <p className='guid' title={'copy to clipboard'}>{user.user.guid}</p>
            </CopyToClipboard></td><td><span className="email-overflow" >{user.user.firstName + " " + user.user.lastName}</span></td><td><span className="email-overflow">{user.user.email}</span></td><td>{this.formatDate(user.statusUpdatedDate)}</td><td>{user.user.mobile}</td><td>{user.facilityRole && user.facilityRole.name ? user.facilityRole.name : ''}</td><td>{user.status}</td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        return (
            <div className="dashboard-inner-content">
                <Header loader={this.state.loader} screenIdentifier={screenIdentifier} />
                <div className="row">
                    <div className="col-xs-4 no-padding">
                        <div className="input-group dashboard-search">
                            <span className="input-group-addon">
                                <span className="icon-search"></span>
                            </span>
                            <input type="text" className="inputText" onKeyUp={this.onSearchChange} required />
                            <span className="floating-label">Search</span>
                        </div>
                    </div>
                    <div className="col-xs-8 list-grid-holder patient-buttons no-padding">
                        <ul className="pull-right d-flex align-items-center">
                            <li className='popup-icon' onClick={() => { this.setState({ showCsvModal: true }) }}>
                                <img src={require('./../../../images/info.png')} alt='info' title="click here to see sample staff csv" />
                            </li>
                            <li>
                                <div className="uploadWrapper">
                                    <label htmlFor="uploadStaffCSV">+ Upload CSV</label>
                                    <input id="uploadStaffCSV" type="file" ref="fileUrl" onChange={this.uploadStaffCSV} />
                                </div>
                            </li>
                            <li>
                                <button className="gray-button" onClick={this.addStaffMember}>+ Add Staff</button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="white-box">
                    <Tabs onSelect={this.handleSelect} selectedIndex={this.state.CurrentTab} >

                        <TabList className="nav nav-tabs">
                            <Tab className="button">ACTIVE</Tab>
                            <Tab className="button">DEACTIVATED</Tab>
                            <Tab className="button">PENDING</Tab>
                            <Tab className="button">EXPIRED</Tab>
                            <Tab className="button">ALL</Tab>
                        </TabList>

                        <TabPanel>
                            <table className="table">
                                {activeStaffData && activeStaffData.length > 0 &&
                                    <thead><tr><th>GUID</th><th><span className="email-overflow">Name</span></th><th><span className="email-overflow">Email</span></th><th>Phone</th><th>Designation</th><th>Edit</th><th>Status</th></tr></thead>
                                }
                                <tbody>
                                    {activeStaffData}
                                </tbody>

                            </table>

                        </TabPanel>
                        <TabPanel>
                            < table className="table">
                                {deactiveStaffData && deactiveStaffData.length > 0 &&
                                    <thead><tr><th>GUID</th><th><span className="email-overflow">Name</span></th><th><span className="email-overflow">Email</span></th><th>Date</th><th>Phone</th><th>Designation</th><th>Status</th></tr></thead>
                                }
                                <tbody>
                                    {deactiveStaffData}
                                </tbody>
                            </table>
                        </TabPanel>
                        <TabPanel>
                            <table className="table">
                                {pendingStaffData && pendingStaffData.length > 0 &&
                                    <thead><tr><th>GUID</th><th><span className="email-overflow">Name</span></th><th><span className="email-overflow">Email</span></th><th>Phone</th><th>Designation</th><th>Status</th><th>Action</th></tr></thead>
                                }
                                <tbody>
                                    {pendingStaffData}
                                </tbody>

                            </table>

                        </TabPanel>
                        <TabPanel>
                            <table className="table">
                                {expiredStaffData && expiredStaffData.length > 0 &&
                                    <thead><tr><th>GUID</th><th><span className="email-overflow">Name</span></th><th><span className="email-overflow">Email</span></th><th>Date</th><th>Phone</th><th>Designation</th><th>Status</th><th>Action</th></tr></thead>
                                }
                                <tbody>
                                    {expiredStaffData}
                                </tbody>

                            </table>

                        </TabPanel>
                        <TabPanel>
                            <table className="table">
                                {allStaffData && allStaffData.length > 0 &&
                                    <thead><tr><th>GUID</th><th><span className="email-overflow">Name</span></th><th><span className="email-overflow">Email</span></th><th>Phone</th><th>Designation</th><th>Edit</th><th>Status</th></tr></thead>
                                }
                                <tbody>
                                    {allStaffData}
                                </tbody>

                            </table>
                        </TabPanel>
                    </Tabs>
                </div>
                {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}
                {(!this.state.loader && this.state.totalRecords >= this.state.PageSize) &&
                    <Pagination
                        activePage={this.state.pageNO}
                        itemsCountPerPage={this.state.PageSize}
                        totalItemsCount={this.state.totalRecords}
                        pageRangeDisplayed={5}
                        onChange={this.onPageChange} />
                }

                {this.state.showCsvModal && <div className='csv-popup'>
                    <div className='popup-overlay' onClick={() => { this.setState({ showCsvModal: false }) }}></div>
                    <div className='csv-info'>
                        <div style={{ margin: '35px' }}>
                            <div className="csvText">Please download the sample template</div>
                            <div className="col-xs-12 no-padding recovery-buttons" style={{ textAlign: 'center' }}>
                                <button className="gray-button" onClick={this.onDownload}>Download</button>
                                <button className="white-button" onClick={() => { this.setState({ showCsvModal: false }) }}>Cancel</button></div>
                        </div>
                        {/* <img src={require('./../../../images/staff.png')} /> */}
                    </div>
                </div>}

                {this.state.isShowDeleteModal && <ModalDialogCommon message={"Are you sure you want to delete?"} action={this.deleteStaffById} cancel={"true"} action2={() => { this.setState({ isShowDeleteModal: false }) }} />}
                {this.state.copiedToClipboard && <ModalDialogCommon message={"Copied to clipboard"} action={this.copied} />}

            </div >

        );
    }
});


let mapStateToProps = (state) => {
    return {
        AllStaffData: state.Patients.AllStaffData,
        UserDetails: state.User,
        userDeleted: state.User.userDeleted

    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    UserActions1: bindActionCreators(UserActions1, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(StaffList));



/** WEBPACK FOOTER **
 ** ./src/components/admin/staff/staffList.js
 **/